import './App.css';
import { useState } from 'react';
import Contact from './components/Javascript/Contact';
import Education from './components/Javascript/Education';
import Footer from './components/Javascript/Footer';
import Head from './components/Javascript/Head';
import Heading from './components/Javascript/Heading';
import Info from './components/Javascript/Info';
import ModeChanger from './components/Javascript/ModeChanger';
import Navbar from './components/Javascript/Navbar';
import Skills from './components/Javascript/Skills'
import Project from './components/Javascript/Project';
import PageNotFound from './components/Javascript/PageNotFound';
import './components/CSS/style.css'
import {
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';
import FloatingModeChanger from './components/Javascript/FloatingModeChanger';

function App() {
  const lightColor = "#DEF2F1";
  const darkColor = "#17252A"
  const lightTextColor = "#2B7A78"
  const darkTextColor = "#3AAFA9"
  const [mode, setMode] = useState("light")
  const [bGColor, setBGColor] = useState(lightColor)
  const [color, setColor] = useState(darkTextColor)
  const onClick = () => {
    if (mode === "light") {
      setMode("dark")
      setBGColor(darkColor)
      setColor(darkTextColor)
      document.body.style.backgroundColor = darkColor;
      document.body.style.color = lightTextColor;
    }
    else {
      setMode("light")
      setBGColor(lightColor)
      setColor(lightTextColor)
      document.body.style.color = darkTextColor;
      document.body.style.backgroundColor = lightColor;
    }
  }
  const handleLightMode = () => {
    setMode("light")
    setBGColor(lightColor)
    setColor(lightTextColor)
    document.body.style.color = darkTextColor;
    document.body.style.backgroundColor = lightColor;
  }
  const handleDarkMode = () => {
    setMode("dark")
    setBGColor(darkColor)
    setColor(darkTextColor)
    document.body.style.backgroundColor = darkColor;
    document.body.style.color = lightTextColor;
  }


  return (
    <>
      <Router>
        <Navbar mode={mode} changeMode={onClick} BGColor={bGColor} color={color} />
        <ModeChanger color={color} BGColor={bGColor} mode={mode} handleLightMode={handleLightMode} handleDarkMode={handleDarkMode} />
        <FloatingModeChanger color={color} BGColor={bGColor} mode={mode} handleLightMode={handleLightMode} handleDarkMode={handleDarkMode} />
        <Head mode={mode} color={color} />
        <Heading heading="So , Who am I?😎" color={color} BGColor={bGColor} />
        <Info color={color} />

        <Heading heading="My Education ✌️" color={color} BGColor={bGColor} />
        <Education color={color} BGColor={bGColor} mode={mode} />

        <Heading heading="My Skills 😉" color={color} BGColor={bGColor} />
        <Skills color={color} BGColor={bGColor} />
        <Heading heading="My Projects😘" color={color} BGColor={bGColor} />
        <Project color={color} BGColor={bGColor} />

        <Heading heading="Contact Me 😍" color={color} BGColor={bGColor} />
        <Contact color={color} BGColor={bGColor} />
        <Routes>
          <Route exact path='/' key="1" element={
            <>
              <Head mode={mode} color={color} />

              <Heading heading="So , Who am I?😎" color={color} BGColor={bGColor} />
              <Info color={color} />

              <Heading heading="My Education ✌️" color={color} BGColor={bGColor} />
              <Education color={color} BGColor={bGColor} mode={mode} />

              <Heading heading="My Skills 😉" color={color} BGColor={bGColor} />
              <Skills color={color} BGColor={bGColor} />
              <Heading heading="My Projects😘" color={color} BGColor={bGColor} />
              <Project color={color} BGColor={bGColor} />

              <Heading heading="Contact Me 😍" color={color} BGColor={bGColor} />
              <Contact color={color} BGColor={bGColor} />
            </>
          } />
          <Route exact path='/about' key="2" element={
            <>
              <Heading heading="So , Who am I?😎" color={color} BGColor={bGColor} />
              <Info color={color} />
              <Heading heading="My Education ✌️" color={color} BGColor={bGColor} />
              <Education color={color} BGColor={bGColor} mode={mode} />
            </>
          } />
          <Route exact path='/project' key="2" element={
            <>
              <Heading heading="My Skills 😉" color={color} BGColor={bGColor} />
              <Skills color={color} BGColor={bGColor} />
              <Heading heading="My Projects😘" color={color} BGColor={bGColor} />
              <Project color={color} BGColor={bGColor} />
            </>
          } />
          <Route exact path='/skills' key="2" element={
            <>
              <Heading heading="My Skills 😉" color={color} BGColor={bGColor} />
              <Skills color={color} BGColor={bGColor} />
            </>
          } />
          <Route exact path='/contactme' key="2" element={
            <>
              <Heading heading="Contact Me 😍" color={color} BGColor={bGColor} />
              <Contact color={color} BGColor={bGColor} />
            </>
          } />
          <Route exact path='/pagenotfound' key="2" element={
            <>
              <PageNotFound />
            </>
          } />
        </Routes>
        <Footer mode={mode} color={color} BGColor={bGColor} />
      </Router >
    </>
  );
}

export default App;
